export default (that) => [
  {
    text: that.$l('btn_tips_view') || '查看版本',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_label_edit') || '编辑版本',
    icon: 'el-icon-edit',
    menuType: 'edit',
    allow: 'M',
    disabled: ({ versionStatus }) => 'N' !== versionStatus
  },
  {
    text: that.$l('menu_label_delete') || '删除版本',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ versionStatus }) => 'N' !== versionStatus
  },
  {
    text: that.$l('menu_label_UploadFilled') || '发布版本',
    icon: 'el-icon-upload',
    menuType: 'uploadFilled',
    allow: 'M',
    divided: true,
    disabled: ({ versionStatus }) => 'N' !== versionStatus
  },
  {
    text: that.$l('menu_label_download') || '下载版本',
    icon: 'el-icon-download',
    menuType: 'viewQrCode',
    allow: 'M',
    divided: true,
    disabled: ({ versionStatus }) => 'D' == versionStatus
  },
  {
    text: that.$l('menu_label_rollback') || '版本回退',
    icon: 'el-icon-refresh-left',
    menuType: 'rollback',
    allow: 'B',
    divided: true,
    disabled: ({ versionStatus }) => ['N', 'D', 'Y'].includes(versionStatus)
  }
]
